export const RolesEnum = {
  OperationsManager: 1,
  ProjectAdministrator: 2,
  ProjectDirector: 3,
  ProjectManager: 4,
  AccountOwner: 5,
};
